import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { ROUTE_PATHS } from "@client-shared/lib/constants";
import { useSFDCAuthState } from "./useSFDCAuthState";

/**
 * Route guard that restricts access to Breville Roaster Admin users only.
 * Non-admin users are redirected to the home page.
 *
 * Usage: wrap the admin route with this component as a parent route.
 */
export const RequireRoasterAdmin: React.FC = () => {
  const [authState] = useSFDCAuthState();

  if (!authState.isRoasterAdmin) {
    return <Navigate to={ROUTE_PATHS.HOME} replace />;
  }

  return <Outlet />;
};
